import { motion } from "framer-motion";
import { CheckCircle } from "lucide-react";

export default function ThankYou() {
  return (
    <div className="min-h-[150vh] md:min-h-[100vh] flex items-center justify-center px-4">
      <motion.div
        initial={{ opacity: 0, y: 40 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, ease: "easeOut" }}
        className="p-5 md:p-10 max-w-[800px] w-full text-center"
      >
        <motion.div
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ delay: 0.2, type: "spring", stiffness: 120 }}
          className="flex justify-center mb-6"
        >
          <CheckCircle size={70} className="text-red-600" />
        </motion.div>

        <h1 className="text-[#0b1534] text-[32px] sm:text-[36px] font-semibold mb-4 leading-normal">
          Thank you for reaching out!
        </h1>

        <p className="text-[#60697b] text-[16px] leading-[26px] mt-8 mb-5">
          We’ve received your details successfully. Our team will review your request and get back to you shortly via phone call and email.
        </p>
        <p className="text-[#60697b] text-[16px] leading-[26px] mb-8">
          In the meantime, feel free to explore our website or learn more about how we help businesses like yours achieve better results.
        </p>
        <motion.a
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          href="/"
          className="inline-block bg-red-600 text-white px-8 py-3 rounded-full text-[16px] font-medium transition hover:bg-red-700"
        >
          Back to Home
        </motion.a>
      </motion.div>
    </div>
  );
}
